module.exports = "/images/new-landing-head.svg?c52891d7053c91127bf364a0d301ab16";